import { render, staticRenderFns } from "./NetaNewMultiEventComponent.vue?vue&type=template&id=659244b0&"
import script from "./NetaNewMultiEventComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewMultiEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewMultiEventComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports